import validateSpanishId from './rules/validateSpanishId';
import validateIBAN from './rules/validateIBAN';
import validateDate from './rules/validateDate';

const regexPrefix = /^\+([0-9]{2})$/;
const regexPhone = /^([9,7,6]{1})+([0-9]{8})$/;
const regexMobile = /^([7,6]{1})+([0-9]{8})$/;
const regexSpanishMobile = /^(\+34)([7,6]{1})+([0-9]{8})$/;
const regexForeignPhone = /^([0-9]+)$/;
const regexZipCode = /0[1-9][0-9]{3}|[1-4][0-9]{4}|5[0-2][0-9]{3}/;
const registrationPlateVehicle = /^[0-9]{4}[BCDFGHJKLMNPRSTVWXYZ]{3}$/;

const validators = Validator => {
  // Prefix
  Validator.extend('prefix', value => regexPrefix.test(value));

  // Phone
  Validator.extend('phone', value => regexPhone.test(value) && value.length === 9);

  // Mobile
  Validator.extend('mobile', value => regexMobile.test(value) && value.length === 9);

  // Phone spanish
  Validator.extend('mobile-prefix', value => {
    if (value.charAt(0) === '+') {
      if (value.substring(0, 3) === '+34') {
        return regexSpanishMobile.test(value) && value.length === 12;
      }
      return regexForeignPhone.test(value.substr(1));
    }
    return regexMobile.test(value) && value.length === 9;
  });

  // Zip code
  Validator.extend('zip_code', value => regexZipCode.test(value) && value.length === 5);

  // DNI
  Validator.extend('dni', value => {
    const { type, valid } = validateSpanishId(value.toUpperCase());
    return type === 'dni' && valid;
  });

  // NIE
  Validator.extend('nie', value => {
    const { type, valid } = validateSpanishId(value.toUpperCase());
    return type === 'nie' && valid;
  });

  // CIF
  Validator.extend('cif', value => {
    const { type, valid } = validateSpanishId(value.toUpperCase());
    return type === 'cif' && valid;
  });

  // Document Number (DNI or NIE)
  Validator.extend('dni_nie', value => {
    const { type, valid } = validateSpanishId(value.toUpperCase());
    return (type === 'dni' || type === 'nie') && valid;
  });

  // IBAN
  Validator.extend('iban', value => validateIBAN(value));

  // Registration plate vehicles
  Validator.extend('registration_plate', value => registrationPlateVehicle.test(value));

  // Date is less than today
  Validator.extend('date_lt_today', value => validateDate('lt', value));

  Validator.extend('file_count', (value, [isOptional, min, max]) => {
    const count = parseInt(value, 10);
    if (!count) {
      return isOptional;
    }
    const nMin = parseInt(min, 10);
    const nMax = max ? parseInt(max, 10) : null;
    if (nMax) {
      return count >= nMin && count <= nMax;
    }
    return count === nMin;
  });

  Validator.extend('required_file', value => {
    if (!value) return false;
    return value > 0;
  });
};

export { validators as default };
